import React from 'react';

import clsx from 'clsx';

import { DoneIcon, InfoWarning } from 'components/common/Icons/Icons';
import { AccountStatus } from 'components/accountStatus/accountStatus.enums';
import styles from 'components/accountStatus/accountStatusHeader/AccountStatusHeader.module.scss';

interface AccountStatusHeaderProps {
  status: AccountStatus;
}

const MAP_ACCOUNT_STATUS_TO_COMPONENT: Record<
  AccountStatus,
  {
    icon: React.JSX.Element;
    className: string;
    additionalText: string;
  }
> = {
  [AccountStatus.ContractorInformationNeeded]: {
    icon: <InfoWarning />,
    className: styles.incompleteStatus,
    additionalText: '',
  },
  [AccountStatus.IntakeNeeded]: {
    icon: <InfoWarning />,
    className: styles.incompleteStatus,
    additionalText: '(Schedule Intake Meeting)',
  },
  [AccountStatus.MdaNeeded]: {
    icon: <InfoWarning />,
    className: styles.incompleteStatus,
    additionalText: '',
  },
  [AccountStatus.Complete]: {
    icon: <DoneIcon />,
    className: styles.successStatus,
    additionalText: '',
  },
};

const AccountStatusHeader = ({ status }: AccountStatusHeaderProps) => {
  const { additionalText, className, icon } = MAP_ACCOUNT_STATUS_TO_COMPONENT[status];

  return (
    <div className={styles.titleBlock}>
      <p className={styles.headerTitle}>Account Status</p>
      <div className={clsx(styles.statusText, className)}>
        <span className={styles.icon}>{icon}</span>
        <p>{status}</p>
        <p className={styles.additionalStatusText}>{additionalText}</p>
      </div>
    </div>
  );
};

export default AccountStatusHeader;
